import useApiController from "@hooks/useApiController"

export default function useSalonController(): General.Controllers.Salon {
    const { index, show, ...controller } = useApiController(`/api/salons`)

    const status = (slug: string) => controller.get(`${slug}/status`)
    const acceptances = (slug: string) => controller.get(`${slug}/acceptances`)
    const awards = (slug: string) => controller.get(`${slug}/awards`)
    const gallery = (slug: string) => controller.get(`${slug}/gallery`)
    const ebook = (slug: string) => controller.newTab(`${slug}/ebook`)

    return { index, show, status, acceptances, awards, gallery, ebook }
}